// extracted by mini-css-extract-plugin
export default {"stickyContainer":"styles_stickyContainer__yE+YU"};